export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12259.cda9e49f.jpg";